// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__JQb87","meals-appear":"AvailableMeals_meals-appear__1rhjB"};